import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation.js";
import { getData } from "../../../fetchRoutes/getData.js";
import PropertyCard from "../../../utility/propertyCard.js";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function PaymentContainer() {

  const myPropertiesUrl = process.env.REACT_APP_CLOSED_AUCTIONS;

  const {isMobile}= useContext(DeviceContext);
  

  const [properties, setProperties] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // eslint-disable-next-line
  const [selectedProperty, setSelectedProperty] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const propertiesPerPage = 8;
  

  const fetchProperties = async () => {
    setLoading(true);
    try {
      const response = await getData(myPropertiesUrl);
      if (response.status === 'Success') {
        setProperties(response.data);
      }
    } catch {
      setError('Failed to fetch properties');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProperties();
    // eslint-disable-next-line
  }, [myPropertiesUrl]);

  const handleAuctionClick = (property) => {
    setSelectedProperty(property);
  };

  const indexOfLastProperty = currentPage * propertiesPerPage;
  const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
  const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);
  const totalPages = Math.ceil(properties.length / propertiesPerPage);

  return (
    <main className="sellerDashboard myPropertiesDashboard">
      {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
      <div className={`container ${properties.length < 4 ? 'moreProperties' : ''}`}>
        <h1 className="containerTitle">REQUEST PAYMENTS</h1>
        <div className="propertyList">
          {isLoading ? (
            <p className="loadingText">Loading properties...</p>
          ) : currentProperties.length > 0 ? (
            currentProperties.map((property) => (
              <PropertyCard
                key={property._id}
                property={property}
                onButtonClick={handleAuctionClick}
                payment={true}
                onPaymentRequested={fetchProperties}
              />
            ))
          ) : (
            <div className="noWonPropertiesContainer">
                <h2 className="noWonPropertiesTitle">Yu have got no payments to process</h2>
                <p className="noWonPropertiesText">Start exploring on live auctions!</p>
                <div className="noWonPropertiesActions">
                    <a href="/auctions" className="wonPropertyButton">Browse Live Auctions</a>
                </div>
            </div>
          )}
          {error && <p className="errorMessage">{error}</p>}
        </div>

        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage((prev) => prev - 1)}
              disabled={currentPage === 1}
              className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
            >
              Previous
            </button>

            <span className="pageInfo">Page {currentPage} of {totalPages}</span>

            <button
              onClick={() => setCurrentPage((prev) => prev + 1)}
              disabled={currentPage === totalPages}
              className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </main>
  );
}
